<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
       <b-card>
          <div slot="header">
            Modification de <strong>l'entête de types d'opérations</strong>  
          </div>
          <b-row class="form-group">
            
            <b-col md="6">
              <label for="libelle">Libelle</label>
              <b-form-input type="text" v-model="typeoperation_headers.libelle" placeholder="Libelle : paiement de masse, transfert d'argent"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="grilletarifaire_libelle">Grille Tarifaire</label>
              <b-form-select id="grilletarifaire_libelle" :plain="true" :options="options_grille" v-model="typeoperation_headers.grilletarifaire_libelle">
              </b-form-select>
              <!--<b-form-input type="text" v-model="typeoperation.sens" placeholder="Sens : Retrait ..."></b-form-input>-->
            </b-col> 
          </b-row>    
          <b-row class="form-group">
            <b-col md="6">
              <label for="taxe">TVA(%)</label>  
              <b-form-input type="number" max="50" v-model="typeoperation_headers.tva" min="0" placeholder=""></b-form-input> 
            </b-col>
          </b-row>      
          <div slot="footer">
            <span v-if="can('typeoperation-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset"  @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      options_sens : [],
      options_grille : [],
      options_tax : [],
      options_code_operation : [{value:'PME',text:'PAIEMENT DE MASSE ENVOIE'},{value:'PMR',text:'PAIEMENT DE MASSE RETRAIT'},{value:'TAR',text:'TRANSFERT D\'ARGENT RETRAIT'},{value:'TAE',text:'TRANSFERT D\'ARGENT ENVOIE'}],
      typeoperation_headers:{    
        libelle: '',
        grilletarifaire_libelle: '',
        tva: '',
        _method:'PUT'
      },
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 20
      }
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async put(){    
        this.response = await this.$store.dispatch('typeoperation_headers/put_typeoperations_headers',{id:this.$route.params.id,typeoperation_headers:this.typeoperation_headers})
        this.showAlert()
        //this.reset()
    },
    can(perm){
      return store.getters['auth/can'](perm)
    },
     async displayHeaders(){
       let response = await this.$store.dispatch('typeoperation_headers/show_typeoperations_headers',this.$route.params.id)
        console.log("response ",response)
        this.typeoperation_headers.grilletarifaire_libelle= response.grilletarifaire_libelle,
        this.typeoperation_headers.libelle= response.libelle,
        this.typeoperation_headers.tva= response.tva
    },
    async get_all_grilletarifaires(){
      await this.$store.dispatch('grilletarifaire/get_all_grilletarifaires',this.serverParams).then(()=>{
        return this.grille =  store.getters['grilletarifaire/rows'];
      })
      this.grille.forEach((element)=>{
          this.options_grille.push({
            value:element.libelle,
            text:element.libelle.toUpperCase()
          })
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    reset(){
      this.typeoperation.libelle= '',
      this.typeoperation.grilletarifaire_libelle= '',
      this.typeoperation.tva=''  
    }
  },
  mounted(){
    this.get_all_grilletarifaires()
    this.displayHeaders()
  }
}
</script>
